<template lang="pug">
window(:title="title", :zGroup=1, :isOpen="isOpen", @closebuttonclick="$emit('update:isOpen', false)", :closeButton="true")
  div(style="display: flex; justify-content: flex-end;")
    button-menu(style="z-index: 3;")
      menu-item(:label=`$t('reset')`, @click="reset")
      menu-item(:label=`$t('go')`, @click="goThere")
  div(style="display: flex; justify-content: center;")
    matrix(:rows=3, :cols="filters.length", :colOneHot="true", v-model="params.mix")
  table(style="min-width: 200px;")
    tbody.inner
      tr
        th E
        td
          log-scale-range(v-model="params.exposure", :min=0, :max="1.e+2")
      tr
        th &gamma;
        td
          log-scale-range(v-model="params.gamma", :min=0, :max="1.e+1")
      tr
        th &#9178;
        td
          log-scale-range(v-model="params.ground", :min=-1, :max=1)
  table(style="min-width: 200px;")
    tbody
      tr.stripe(v-for="(filter, i) in filters")
        th(v-html="filter", style="width: 10%;")
        td
          table
            tbody.inner
              tr
                th &beta;
                td
                  log-scale-range(v-model="params.beta[i]", :min=0, :max="5.e+4")
              tr
                th a
                td
                  log-scale-range(v-model="params.a[i]", :min=0, :max=15, :a="20")
              tr
                th b
                td
                  log-scale-range(v-model="params.b[i]", :min=-2, :max=2, :a="1.e+1")
              tr
                th B
                td
                  log-scale-range(v-model="params.bias[i]", :min=-1, :max=1)
  //- input(type="text", :value="JSON.stringify(params)", style={width: '100%', margin: '1em 0'},)
</template>

<script lang="ts">
import Matrix from "@/components/Matrix/index.vue";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { defaultParams } from '@/modules/layers/PrettyPictureLayer/defaultParams';

@Component({
  components: { Matrix },
})
export default class extends Vue {
  @Prop({ required: true })
  isOpen!: boolean

  @Prop({ required: true })
  title!: string

  @Prop({ required: true })
  filters!: string[]

  @Prop({ required: true })
  params!: ReturnType<typeof defaultParams>["m31"]

  @Prop({ required: true })
  reset!: () => void

  @Prop({ required: true })
  goThere!: () => void
}
</script>


<i18n>
en:
  reset: Reset
  go: Go There
ja:
  reset: リセット
  go: 表示
</i18n>


<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

.inner th {
  width: 10%;
}

tr.stripe:nth-child(even) {
  background-color: rgba(63, 63, 63, 0.75);
}
</style>